/**
 * Resource role keys: `-` and `_` mean the same thing.
 *
 * Resource-plan profiles staff kebab-case role ids (`lead-consultant`). Until #122 the
 * Workspace -> Resources tab created underscore keys (`lead_consultant`), so a catalog
 * row the plan clearly meant never matched and the role priced at 0 h. Every place a
 * plan's role id meets the catalog compares through these helpers - nothing else does
 * its own hyphen/underscore matching.
 *
 * Only `_` vs `-` is folded. Case and other characters still have to match: role keys
 * are machine keys, and a looser rule would start merging roles that really differ.
 */
/** The spelling two role keys are compared under: every `_` becomes `-`. */
export function canonicalRoleKey(key) {
    return key.replace(/_/g, '-');
}
/** True when two role keys differ at most by `-` vs `_`. */
export function sameRoleKey(a, b) {
    return canonicalRoleKey(a) === canonicalRoleKey(b);
}
/**
 * Resolve the catalog key a wanted role key refers to.
 *
 * - An exact spelling always wins (`match`), and any other spellings of the same role
 *   are returned in `duplicates` so the caller can warn about them.
 * - Otherwise the single other-spelling key is the match.
 * - Two other spellings and no exact one (`a_b-c` and `a-b_c` for `a-b-c`) is ambiguous:
 *   no match, both in `duplicates`.
 */
export function matchRoleKey(wanted, available) {
    const canon = canonicalRoleKey(wanted);
    const same = [...new Set(available)].filter((k) => canonicalRoleKey(k) === canon);
    if (same.includes(wanted)) {
        return { match: wanted, duplicates: same.filter((k) => k !== wanted) };
    }
    if (same.length === 1)
        return { match: same[0], duplicates: [] };
    return { match: null, duplicates: same };
}
//# sourceMappingURL=role-key.js.map